import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import * as htmlParser from 'react-markdown/plugins/html-parser';
import * as HtmlToReact from 'html-to-react';

export interface IMarkdownProps {
    text: string;
}

const allowedNodeTypes: string[] = ['b', 'alert', 'p'];
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

const parseHtml = htmlParser({
    isValidNode: (node: any) =>  allowedNodeTypes.indexOf(node.name) > -1 || node.type === 'text',
    processingInstructions: [
        {
            // alert tag
            shouldProcessNode: (node: any) => {
                return node && node.name && node.name === 'alert';
            },
            processNode: (node: any, children: any) => {
                return React.createElement('span', {className: "alert-text"}, children)
            }
        },
        {
          // Anything else
          shouldProcessNode: (node: any) =>  {
            return true;
          },
          processNode: processNodeDefinitions.processDefaultNode
        }]
})

export const Markdown = (props: IMarkdownProps) => {    
    return (
        <ReactMarkdown
            disallowedTypes={['paragraph']}
            unwrapDisallowed={true}
            source={props.text}
            escapeHtml={false}
            astPlugins={[parseHtml]}
            />
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/localization/markdown-wrapper.tsx